import { FoundationsEnums } from '../../enum'
import { getVUChartSwitchObject } from '../../VisualunitHelpers'
import { VisualUnitApiDTO_VisualUnit } from '../../Interfaces/APIContracts/VisualUnitApiDTO_VisualUnit'
import { useZustandVisualUnitStore } from './vuContext'

interface SwitchProps {
    visualUnitId: number
    viewerType: number
    vuDetail: VisualUnitApiDTO_VisualUnit
    vuChartSwitchCurr: { [s: string]: any }
    closeWindow: () => void
}

export const SwitchOrganizer = (props: SwitchProps) => {
    const { visualUnitId, viewerType, vuDetail, vuChartSwitchCurr, closeWindow } =
        props
    const itemName = 'vu_switch_item'
    const itemLabelFilter =
        viewerType == FoundationsEnums.VisualUnitViewerType.Chart_ColumnGroup ? 'group' : 'filter'

    const IsChartSwitchFilterAllowed = () => {
        if (viewerType == FoundationsEnums.VisualUnitViewerType.Chart_Scatter) {
            return false
        }
        if (
            (vuDetail.XAxisList.length == 1 && vuDetail.YAxisList.length == 2) ||
            (vuDetail.XAxisList.length == 2 && vuDetail.YAxisList.length == 1)
        ) {
            return true
        }
        return false
    }

    const updateChartSwitchSettings = useZustandVisualUnitStore((s) => s.updateChartSwitchSettings);

    const runChartSwitchDimension = (dimId: any, dimbinId: any, switchType: string) => {
        const chartSwitch = getChartSwitchDimension(vuChartSwitchCurr, dimId, dimbinId, switchType)
        updateChartSwitchSettings(chartSwitch)
        closeWindow()
        return false
    }

    const XAxisContent = (props: { innerVuDetail: { [s: string]: any } }) => {
        const { innerVuDetail } = props
        if (
            vuChartSwitchCurr !== undefined &&
            vuChartSwitchCurr !== null &&
            vuChartSwitchCurr.CategoryMetaDataId === innerVuDetail.MetaDataId &&
            vuChartSwitchCurr.CategoryMetaDataBinId == innerVuDetail.MetaDataBin.Id
        ) {
            if (viewerType === FoundationsEnums.VisualUnitViewerType.Chart_Pie) {
                return (
                    <li
                        className="switch-item switch-item-disabled"
                        title="Cannot switch axes on pie chart"
                    >
                        x-axis
                    </li>
                )
            } else {
                if (innerVuDetail.DisplayOrder != 1) {
                    //FP-9466. Fixed a bug. It was causing an issue when user select two same measures with different aggregate function.
                    return <li className="switch-item switch-item-current">x-axis</li>
                } else {
                    return (
                        <li
                            id={`${itemName}_${visualUnitId}_${innerVuDetail.MetaDataId}_${innerVuDetail.MetaDataBin.Id}_${'category'}`}
                            className="switch-item switch-item-allowed"
                            onClick={() =>
                                runChartSwitchDimension(
                                    innerVuDetail.MetaDataId,
                                    innerVuDetail.MetaDataBin.Id,
                                    'category'
                                )
                            }
                        >
                            x-axis
                        </li>
                    )
                }
            }
        } else {
            if (viewerType === FoundationsEnums.VisualUnitViewerType.Chart_Pie) {
                return (
                    <li
                        id={`${itemName}_${visualUnitId}_${innerVuDetail.MetaDataId}_${innerVuDetail.MetaDataBin.Id}_${'category'}`}
                        className="switch-item switch-item-disabled"
                        title="Cannot switch axes on pie chart"
                    >
                        x-axis
                    </li>
                )
            } else if (
                viewerType == FoundationsEnums.VisualUnitViewerType.Chart_Scatter &&
                innerVuDetail.DisplayOrder == 0
            ) {
                return <li className="switch-item switch-item-current">x-axis</li>
            } else {
                return (
                    <li
                        id={`${itemName}_${visualUnitId}_${innerVuDetail.MetaDataId}_${innerVuDetail.MetaDataBin.Id}_${'category'}`}
                        className="switch-item switch-item-allowed"
                        onClick={() =>
                            runChartSwitchDimension(
                                innerVuDetail.MetaDataId,
                                innerVuDetail.MetaDataBin.Id,
                                'category'
                            )
                        }
                    >
                        x-axis
                    </li>
                )
            }
        }
    }

    const SeriesContent = (props: { innerVuDetail: { [s: string]: any } }) => {
        const { innerVuDetail } = props
        if (
            vuChartSwitchCurr !== null &&
            vuChartSwitchCurr.SeriesMetaDataId === innerVuDetail.MetaDataId &&
            vuChartSwitchCurr.SeriesMetaDataBinId === innerVuDetail.MetaDataBin.Id &&
            viewerType != FoundationsEnums.VisualUnitViewerType.Chart_Scatter
        ) {
            if (viewerType == FoundationsEnums.VisualUnitViewerType.Chart_Pie) {
                return (
                    <li
                        className="switch-item switch-item-disabled"
                        title="Cannot switch axes on pie chart"
                    >
                        series
                    </li>
                )
            } else {
                return <li className="switch-item switch-item-current">series</li>
            }
        } else {
            if (viewerType == FoundationsEnums.VisualUnitViewerType.Chart_Pie) {
                return (
                    <li
                        id={`${itemName}_${visualUnitId}_${innerVuDetail.MetaDataId}_${innerVuDetail.MetaDataBin.Id}_${'series'}`}
                        className="switch-item switch-item-disabled"
                        title="Cannot switch axes on pie chart"
                    >
                        series
                    </li>
                )
            } else if (viewerType == FoundationsEnums.VisualUnitViewerType.Chart_Scatter) {
                if (innerVuDetail.DisplayOrder == 1) {
                    return <li className="switch-item switch-item-current">y-axis</li>
                } else {
                    return (
                        <li
                            id={`${itemName}_${visualUnitId}_${innerVuDetail.MetaDataId}_${innerVuDetail.MetaDataBin.Id}_${'series'}`}
                            className="switch-item switch-item-allowed"
                            onClick={() =>
                                runChartSwitchDimension(
                                    innerVuDetail.MetaDataId,
                                    innerVuDetail.MetaDataBin.Id,
                                    'series'
                                )
                            }
                        >
                            y-axis
                        </li>
                    )
                }
            } else {
                return (
                    <li
                        id={`${itemName}_${visualUnitId}_${innerVuDetail.MetaDataId}_${innerVuDetail.MetaDataBin.Id}_${'series'}`}
                        className="switch-item switch-item-allowed"
                        onClick={() =>
                            runChartSwitchDimension(
                                innerVuDetail.MetaDataId,
                                innerVuDetail.MetaDataBin.Id,
                                'series'
                            )
                        }
                    >
                        series
                    </li>
                )
            }
        }
    }

    const FilterContent = (props: { innerVuDetail: { [s: string]: any } }) => {
        const { innerVuDetail } = props
        if (IsChartSwitchFilterAllowed()) {
            if (
                vuChartSwitchCurr.FilterMetaDataId === innerVuDetail.MetaDataId &&
                vuChartSwitchCurr.FilterMetaDataBinId === innerVuDetail.MetaDataBin.Id
            ) {
                if (viewerType != FoundationsEnums.VisualUnitViewerType.Chart_Pie) {
                    return <li className="switch-item switch-item-current">{itemLabelFilter}</li>
                } else {
                    return (
                        <li
                            className="switch-item switch-item-disabled"
                            title="Cannot switch axes on pie chart"
                        >
                            {itemLabelFilter}
                        </li>
                    )
                }
            } else {
                if (viewerType != FoundationsEnums.VisualUnitViewerType.Chart_Pie) {
                    return (
                        <li
                            id={`${itemName}_${visualUnitId}_${innerVuDetail.MetaDataId}_${innerVuDetail.MetaDataBin.Id}_${'filter'}`}
                            className="switch-item switch-item-allowed"
                            onClick={() =>
                                runChartSwitchDimension(
                                    innerVuDetail.MetaDataId,
                                    innerVuDetail.MetaDataBin.Id,
                                    'filter'
                                )
                            }
                        >
                            {itemLabelFilter}
                        </li>
                    )
                } else {
                    return (
                        <li
                            id={`${itemName}_${visualUnitId}_${innerVuDetail.MetaDataId}_${innerVuDetail.MetaDataBin.Id}_${'filter'}`}
                            className="switch-item switch-item-disabled"
                            title="Cannot switch axes on pie chart"
                        >
                            {itemLabelFilter}
                        </li>
                    )
                }
            }
        }
    }

    const InnerSwitchContent = (props: { innerVuDetail: { [s: string]: any } }) => {
        const { innerVuDetail } = props
        const metadataBinName = innerVuDetail.MetaDataBin.Name
        let metadataBinString = ''
        if (metadataBinName !== null && metadataBinName !== '') {
            metadataBinString = `<div className='vu-chart-switch-bin-name'>(${metadataBinName})</div>`
        }
        return (
            <tr>
                <td className="vu-chart-switch-name">
                    {innerVuDetail.MetaData.FieldName} {metadataBinName}
                </td>
                <td className="vu-chart-switch-data">
                    <ul className="vu-chart-switch-list">
                        <XAxisContent innerVuDetail={innerVuDetail} />
                        <SeriesContent innerVuDetail={innerVuDetail} />
                        <FilterContent innerVuDetail={innerVuDetail} />
                    </ul>
                    <span className="2"></span>
                </td>
            </tr>
        )
    }

    if (viewerType === FoundationsEnums.VisualUnitViewerType.Chart_Scatter) {
        return (
            <div id="dashboard_vu_switch_wrapper">
                <table className="vu-chart-switch">
                    <tbody>
                        {vuDetail.MeasureList.map((measureVUDetail: { [s: string]: any }) => (
                            <InnerSwitchContent
                                innerVuDetail={measureVUDetail}
                            ></InnerSwitchContent>
                        ))}
                    </tbody>
                </table>
            </div>
        )
    } else if (vuDetail.XAxisList.length > 0 || vuDetail.YAxisList.length > 0) {
        return (
            <div id="dashboard_vu_switch_wrapper">
                <table className="vu-chart-switch">
                    <tbody>
                        {vuDetail.XAxisList.map((xAxisVUDetail: { [s: string]: any }) => (
                            <InnerSwitchContent innerVuDetail={xAxisVUDetail}></InnerSwitchContent>
                        ))}
                        {vuDetail.YAxisList.map((yAxisVUDetail: { [s: string]: any }) => (
                            <InnerSwitchContent innerVuDetail={yAxisVUDetail}></InnerSwitchContent>
                        ))}
                    </tbody>
                </table>
            </div>
        )
    } else {
        return (
            <div id="dashboard_vu_switch_wrapper">
                <div className="vu-chart-switch">No dimensions found.</div>
            </div>
        )
    }
}

// data_chartSwitch = resultData.chartSwitch, vuDataObj
const getChartSwitchDimension = (
    chartSwitch: any,
    dimId: any,
    dimbinId: any,
    switchType: string
) => {
    let vuChartSwitch = getVUChartSwitchObject()

    // var vuId = healthLevelGlobal.parseInteger(matches[2]);
    // var dimId = healthLevelGlobal.parseInteger(matches[3]);
    // var dimbinId = healthLevelGlobal.parseInteger(matches[4]);
    // var switchType = matches[5];

    let vuChartSwitchCurr = chartSwitch

    if (vuChartSwitchCurr != undefined) {
        switch (switchType) {
            case 'category':
                vuChartSwitch.ApplySwitchValues = true
                vuChartSwitch.CategoryMetaDataId = dimId
                vuChartSwitch.CategoryMetaDataBinId = dimbinId
                if (
                    dimId == vuChartSwitchCurr.SeriesMetaDataId &&
                    dimbinId == vuChartSwitchCurr.SeriesMetaDataBinId
                ) {
                    vuChartSwitch.SeriesMetaDataId = vuChartSwitchCurr.CategoryMetaDataId
                    vuChartSwitch.SeriesMetaDataBinId = vuChartSwitchCurr.CategoryMetaDataBinId
                    vuChartSwitch.FilterMetaDataId = vuChartSwitchCurr.FilterMetaDataId
                    vuChartSwitch.FilterMetaDataBinId = vuChartSwitchCurr.FilterMetaDataBinId
                } else {
                    vuChartSwitch.SeriesMetaDataId = vuChartSwitchCurr.FilterMetaDataId
                    vuChartSwitch.SeriesMetaDataBinId = vuChartSwitchCurr.FilterMetaDataBinId
                    vuChartSwitch.FilterMetaDataId = vuChartSwitchCurr.CategoryMetaDataId
                    vuChartSwitch.FilterMetaDataBinId = vuChartSwitchCurr.CategoryMetaDataBinId
                }
                break
            case 'series':
                vuChartSwitch.ApplySwitchValues = true
                vuChartSwitch.SeriesMetaDataId = dimId
                vuChartSwitch.SeriesMetaDataBinId = dimbinId
                if (
                    dimId == vuChartSwitchCurr.CategoryMetaDataId &&
                    dimbinId == vuChartSwitchCurr.CategoryMetaDataBinId
                ) {
                    vuChartSwitch.CategoryMetaDataId = vuChartSwitchCurr.SeriesMetaDataId
                    vuChartSwitch.CategoryMetaDataBinId = vuChartSwitchCurr.SeriesMetaDataBinId
                    vuChartSwitch.FilterMetaDataId = vuChartSwitchCurr.FilterMetaDataId
                    vuChartSwitch.FilterMetaDataBinId = vuChartSwitchCurr.FilterMetaDataBinId
                } else {
                    vuChartSwitch.CategoryMetaDataId = vuChartSwitchCurr.CategoryMetaDataId
                    vuChartSwitch.CategoryMetaDataBinId = vuChartSwitchCurr.CategoryMetaDataBinId
                    vuChartSwitch.FilterMetaDataId = vuChartSwitchCurr.SeriesMetaDataId
                    vuChartSwitch.FilterMetaDataBinId = vuChartSwitchCurr.SeriesMetaDataBinId
                }
                break
            case 'filter':
                vuChartSwitch.ApplySwitchValues = true
                vuChartSwitch.FilterMetaDataId = dimId
                vuChartSwitch.FilterMetaDataBinId = dimbinId
                if (
                    dimId == vuChartSwitchCurr.CategoryMetaDataId &&
                    dimbinId == vuChartSwitchCurr.CategoryMetaDataBinId
                ) {
                    vuChartSwitch.CategoryMetaDataId = vuChartSwitchCurr.FilterMetaDataId
                    vuChartSwitch.CategoryMetaDataBinId = vuChartSwitchCurr.FilterMetaDataBinId
                    vuChartSwitch.SeriesMetaDataId = vuChartSwitchCurr.SeriesMetaDataId
                    vuChartSwitch.SeriesMetaDataBinId = vuChartSwitchCurr.SeriesMetaDataBinId
                } else {
                    vuChartSwitch.CategoryMetaDataId = vuChartSwitchCurr.CategoryMetaDataId
                    vuChartSwitch.CategoryMetaDataBinId = vuChartSwitchCurr.CategoryMetaDataBinId
                    vuChartSwitch.SeriesMetaDataId = vuChartSwitchCurr.FilterMetaDataId
                    vuChartSwitch.SeriesMetaDataBinId = vuChartSwitchCurr.FilterMetaDataBinId
                }
                break
        }
    }
    return vuChartSwitch
}
